'use client'
import {
  CarouselWithLink_default
} from "./chunk-LVDZESI2.mjs";
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";

// src/components/blog/BlogSection.tsx
import { useBlogList } from "@wbk/api/hooks";
import { ImageWithFallback } from "@wbk/ui";
import { useRouter } from "@wbk/config";
import { useAnalytics } from "@wbk/analytics";
import { jsx, jsxs } from "react/jsx-runtime";
var BlogSection = ({ section }) => {
  const { locale } = useRouter();
  const { data } = useBlogList({ lang: locale });
  const { trackEvent } = useAnalytics();
  if (!data || data.length === 0) return null;
  return /* @__PURE__ */ jsx(
    DecoratedSection_default,
    {
      section,
      className: "container overflow-hidden",
      "data-testid": `section_blog_section_${section.id}`,
      children: /* @__PURE__ */ jsx(
        CarouselWithLink_default,
        {
          section,
          containerClassName: "gap-4 py-1",
          linkClassName: "shrink-0 basis-[95%] sm:basis-1/2 md:basis-1/3 lg:basis-1/4 xl:basis-[23%] aspect-1",
          children: data.map((article, index) => /* @__PURE__ */ jsx(
            "a",
            {
              href: article.link,
              onClick: () => {
                var _a;
                return trackEvent({
                  event: "clicked_on_section_item",
                  data: {
                    type: "blog",
                    item_id: String(article.id),
                    slug: article.slug,
                    label: (_a = article.title) == null ? void 0 : _a.rendered,
                    section: section.id,
                    position: index
                  }
                });
              },
              "data-testid": `section_blog_item_${article.id}`,
              className: "shrink-0 basis-[95%] sm:basis-1/2 md:basis-1/3 lg:basis-1/4 xl:basis-[23%]",
              children: /* @__PURE__ */ jsx("div", { className: "aspect-1 rounded-lg md:aspect-[3/2.5]", children: /* @__PURE__ */ jsxs("div", { className: "relative h-full overflow-hidden rounded-lg bg-cover transition duration-500", children: [
                /* @__PURE__ */ jsx("div", { className: "absolute inset-0 z-10 scale-105 bg-gradient-to-b from-black/5 via-black/60 to-black/95 to-90%" }),
                /* @__PURE__ */ jsx(
                  ImageWithFallback,
                  {
                    className: "aspect-1 absolute h-full object-cover transition duration-300 group-hover:scale-105 group-focus:scale-105",
                    src: article.featured_image_url,
                    width: 800,
                    height: 800,
                    alt: article.title.rendered
                  }
                ),
                /* @__PURE__ */ jsxs("div", { className: "relative z-20 flex h-full w-full flex-col justify-between overflow-hidden p-4", children: [
                  /* @__PURE__ */ jsx("div", {}),
                  /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: "line-clamp-2 text-xl",
                        dangerouslySetInnerHTML: { __html: article.title.rendered }
                      }
                    ),
                    article.excerpt.rendered && /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: "line-clamp-2 text-sm",
                        dangerouslySetInnerHTML: { __html: article.excerpt.rendered }
                      }
                    )
                  ] })
                ] })
              ] }) })
            },
            article.id
          ))
        }
      )
    }
  );
};
var BlogSection_default = BlogSection;

export {
  BlogSection_default
};
//# sourceMappingURL=chunk-KLO375RW.mjs.map